$(function () {

    $('input[name="keyword"]', $('#search_pexels')).keyconfirm({
        onConfirm: function (el, e) {
            searchPexels(e)
        }
    });
    
    $('button[name="submit"]', $('#search_pexels')).on('click', searchPexels);
});

function searchPexels(e) {
    e.preventDefault();

    var form = $("#search_pexels");

    $('input[name="keyword"]', form).attr('disabled', true);
    $('button[name="submit"]', form).attr('disabled', true);

    $.post(url + "/pexels/search",
        {
            '_token': $('input[name="_token"]', form).val(),
            'keyword': $('input[name="keyword"]', form).val()
        },
        function (response) {

            $('input[name="keyword"]', form).attr('disabled', false);
            $('button[name="submit"]', form).attr('disabled', false);

            if (response.success == false) {
                systemalert(response.message, 'warning');
            } else {
                $('img', $('#pexels_gallery')).remove();
                $.each(response.data.photos, function (key, photo) {
                    var img = $('<img>').attr('src', photo.src.tiny).attr('data-original', photo.src.original).attr('name', 'pexels_image');

                    img.on('click', imageToHiddenField);

                    $('#pexels_gallery').append(img);
                });

                //systemalert(response.message, 'success');
            }

        }.bind(this),
        'json'
    )
    .fail(function () {
        $('input[name="keyword"]', form).attr('disabled', false);
        $('button[name="submit"]', form).attr('disabled', false);
        $('#modal-search-pexels').modal('hide');
        systemalert('There was an system error, please notify an admin!', 'danger');
    })
}

function imageToHiddenField(e) {
    e.preventDefault();

    var thumbnail = $(this).attr('src');
    var original = $(this).attr('data-original');

    // add image to hidden fiels
    $('input[name="header_pexels"]', $('#add_goal')).attr('value', original);

    // add thumbnail
    var img = $('<img>').attr('src', thumbnail).attr('data-original', original).css('max-height', 154);
    $('.fileinput-preview', $('#add_goal .fileinput-header')).html(img);

    $('#add_goal .fileinput-header').removeClass('fileinput-new').addClass('fileinput-exists');

    // hide popup
    $('#modal-search-pexels').modal('hide');

    // show message
    systemalert('Your image has been added', 'success')
}

// function savePexelPhoto(e) {
//     e.preventDefault();
//
//     var form = $("#savePhotoForm");
//
//     $.post("/savePexel",
//         {
//             '_token': $('input[name="_token"]', form).val(),
//             '_photo': $('input[name="_photo"]', form).val(),
//         },
//         function (response) {
//             if (response.success == false) {
//                 systemalert(response.message, 'warning');
//             } else {
//                 systemalert(response.message, 'success');
//             }
//
//         }.bind(this),
//         'json'
//     )
//         .fail(function () {
//             $(this).attr('disabled', false);
//             systemalert('There was an system error, please notify an admin!', 'danger');
//         })
// }